import * as React from 'react';
import { useSelector } from 'react-redux';

import { ListCard } from 'shared/components/ListCard';

import { MyHomeWithSliderListing } from 'shared/components/MyHomeListing';
import { MyHomeListing } from 'shared/components/MyHomeListing/MyHomeListing';
import { useGetGoToOtherMyHomeCard } from '../hooks/useGetGoToOtherMyHomeCard';
import { useGetMyHomeListing } from '../hooks/useGetMyHomeListing';
import { selectMyHomeId } from '../../../selectors/selectMyHomeId';

export const MyHomeListingContainer: React.FC = () => {
  const myHomeItems = useGetMyHomeListing();
  const myHomeId = useSelector(selectMyHomeId);

  const onGoToOtherMyHomeCard = useGetGoToOtherMyHomeCard();

  if (!myHomeItems) {
    return null;
  }

  /**
   * Если карточек меньше чем 4, слайдер не требуется
   */
  if (myHomeItems.length < 4) {
    return (
      <MyHomeListing>
        {myHomeItems.map(item => (
          <ListCard
            key={item.id}
            isDesktop={true}
            onClick={() => onGoToOtherMyHomeCard(item.id)}
            isActive={item.id === myHomeId}
            address={item.address}
            title={item.title}
          />
        ))}
      </MyHomeListing>
    );
  }

  return (
    <MyHomeWithSliderListing>
      {myHomeItems.map(item => (
        <ListCard
          key={item.id}
          isDesktop={true}
          onClick={() => onGoToOtherMyHomeCard(item.id)}
          isActive={item.id === myHomeId}
          address={item.address}
          title={item.title}
        />
      ))}
    </MyHomeWithSliderListing>
  );
};

MyHomeListingContainer.displayName = 'MyHomeListingContainer';
